namespace TabAurous.Purchase {
    export namespace GSTR2Service {
        export const baseUrl = 'Purchase/GSTR2';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/GSTR2/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>GSTR2Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
